import { observable } from 'mobx';
// when configured App gets data loaded onto it,
// we generate IDs and put them into the AppStore

export const Cache = observable.map();
